import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-317f732f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "dialog-buttons" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NameColorForm = _resolveComponent("NameColorForm")!
  const _component_NameCharForm = _resolveComponent("NameCharForm")!
  const _component_RandselDialog = _resolveComponent("RandselDialog")!

  return (_openBlock(), _createBlock(_component_RandselDialog, {
    ref: "root",
    title: _ctx.currentPage == 0 ? 'ししゅうのいろ' : 'ししゅうする文字',
    showEventName: "openMobileNameDialog",
    class: "name-dialog",
    onOnShow: _ctx.onShow
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onRemoveClick && _ctx.onRemoveClick(...args)))
        }, "ネームをクリア"),
        _withDirectives(_createElementVNode("button", {
          disabled: !_ctx.configNamethreadId,
          class: "pink-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
        }, "次へ", 8, _hoisted_4), [
          [_vShow, _ctx.currentPage == 0]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "pink-button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSaveClick && _ctx.onSaveClick(...args)))
        }, "ネームを保存", 512), [
          [_vShow, _ctx.currentPage == 1]
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.currentPage == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_NameColorForm, { ref: "colorForm" }, null, 512)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.currentPage == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_NameCharForm, { ref: "charForm" }, null, 512)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "onOnShow"]))
}